<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between align-items-center">
      <div class="p-3">Partner Limits</div>
      <!-- <button class="btn btn-info btn-sm bg-white me-3 mt-3 mb-3" (click)="openAddModal()">Add New</button> -->
    </div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-12 mt-4 mb-5">
        <div class="table-responsive">
          <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
            [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #editModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Edit Partner Limit</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <div class="container-fluid">
      @if (editErrorMessage) {
        <div class="alert alert-danger" role="alert">{{ editErrorMessage }}</div>
      }
      <div class="row pt-2">
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label">Partner</label>
            <input type="text" class="form-control bg-secondary bg-opacity-10 border-secondary" [value]="selectedLimit?.partnerId?.name" readonly disabled>
          </div>

          <div class="mb-3">
            <label class="form-label">Partner Type</label>
            <input type="text" class="form-control bg-secondary bg-opacity-10 border-secondary" [value]="selectedLimit?.partnerId?.type" readonly disabled>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">Daily Limit</label>
                <div class="input-group">
                  <span class="input-group-text">{{ selectedLimit?.partnerCurrency }}</span>
                  <input type="number" class="form-control" [(ngModel)]="editForm.dailyLimit" min="0">
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">Monthly Limit</label>
                <div class="input-group">
                  <span class="input-group-text">{{ selectedLimit?.partnerCurrency }}</span>
                  <input type="number" class="form-control" [(ngModel)]="editForm.monthlyLimit" min="0">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">Daily Transaction Limit</label>
                <input type="number" class="form-control" [(ngModel)]="editForm.dailyTransactionLimit" min="1">
              </div>
            </div>
          </div>

          <!-- Transaction Limits -->
          <div class="mt-4">
            <h5>Transaction Limits</h5>

            <div class="mb-3">
              <h6>Transfer</h6>
              <div class="row">
                <div class="col-md-6">
                  <label class="form-label">Min Amount</label>
                  <div class="input-group">
                    <span class="input-group-text">{{ selectedLimit?.partnerCurrency }}</span>
                    <input type="number" class="form-control" [(ngModel)]="editForm.transactionLimits.transfer.minAmount" min="0">
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Max Amount</label>
                  <div class="input-group">
                    <span class="input-group-text">{{ selectedLimit?.partnerCurrency }}</span>
                    <input type="number" class="form-control" [(ngModel)]="editForm.transactionLimits.transfer.maxAmount" min="0">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="updateLimit()" [disabled]="!isFormValid()">Update</button>
  </div>
</ng-template>

<ng-template #addModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Add Partner Limit</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <div class="container-fluid">
      @if (addErrorMessage) {
        <div class="alert alert-danger" role="alert">{{ addErrorMessage }}</div>
      }
      <div class="row pt-2">
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label">Partner</label>
            <select class="form-select" [(ngModel)]="addForm.partnerId" required>
              <option value="">Select a Partner</option>
              @for (partner of partners; track partner) {
                <option [value]="partner._id">{{ partner.name }} ({{ partner.type }})</option>
              }
            </select>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">Daily Limit</label>
                <div class="input-group">
                  <span class="input-group-text">$</span>
                  <input type="number" class="form-control" [(ngModel)]="addForm.dailyLimit" min="0">
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">Monthly Limit</label>
                <div class="input-group">
                  <span class="input-group-text">{{ selectedLimit?.partnerCurrency || '$' }}</span>
                  <input type="number" class="form-control" [(ngModel)]="addForm.monthlyLimit" min="0">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">Daily Transaction Limit</label>
                <input type="number" class="form-control" [(ngModel)]="addForm.dailyTransactionLimit" min="1">
              </div>
            </div>
          </div>

          <!-- Transaction Limits -->
          <div class="mt-4">
            <h5>Transaction Limits</h5>

            <div class="mb-3">
              <h6>Transfer</h6>
              <div class="row">
                <div class="col-md-6">
                  <label class="form-label">Min Amount</label>
                  <input type="number" class="form-control" [(ngModel)]="addForm.transactionLimits.transfer.minAmount" min="0">
                </div>
                <div class="col-md-6">
                  <label class="form-label">Max Amount</label>
                  <input type="number" class="form-control" [(ngModel)]="addForm.transactionLimits.transfer.maxAmount" min="0">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="addLimit()" [disabled]="!isAddFormValid()">Add</button>
  </div>
</ng-template>
